(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const closeButton = document.querySelector('.js-admin-product-detail-preview-close');
        if (!closeButton) {
            return;
        }

        closeButton.addEventListener('click', function () {
            window.close();
        });
    });
})();
